"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIIconButton = _interopRequireDefault(require("UIComponents/button/UIIconButton"));

var _colors = require("HubStyleTokens/colors");

var FilterDeleteButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterDeleteButton, _PureComponent);

  function FilterDeleteButton() {
    (0, _classCallCheck2.default)(this, FilterDeleteButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterDeleteButton).apply(this, arguments));
  }

  (0, _createClass2.default)(FilterDeleteButton, [{
    key: "render",
    value: function render() {
      var onClick = this.props.onClick;
      return _react.default.createElement(_UIIconButton.default, {
        className: "targeting-option__delete-button",
        onClick: onClick,
        placement: "right",
        use: "unstyled"
      }, _react.default.createElement(_UIIcon.default, {
        color: _colors.CALYPSO,
        name: "delete"
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        onClick: _react.PropTypes.func.isRequired
      };
    }
  }]);
  return FilterDeleteButton;
}(_react.PureComponent);

exports.default = FilterDeleteButton;
module.exports = exports.default;